import { Skeleton } from "primereact/skeleton";
import { useContext } from "react";
import { ThemeContext } from "../../../theme/ThemeContext";

const CatStatsCard = ({
  title,
  value,
  icon,
  bgColor = "#fff",
  loading = false,
}) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  const cardBgColor = loading ? (isDark ? "#191919" : "#fff") : bgColor;

  return (
    <div
      className="h-100 border-0 rounded-3 shadow d-flex flex-column justify-content-center"
      style={{
        backgroundColor: cardBgColor,
        minHeight: "160px",
        padding: "1rem",
      }}
    >
      {loading ? (
        <div
          className="d-flex align-items-center w-100"
          style={{ gap: "14px" }}
        >
          <Skeleton shape="circle" size="50px" />
          <div
            style={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Skeleton width="70%" height="18px" />
            <Skeleton width="50%" height="28px" />
          </div>
        </div>
      ) : (
        <div className="d-flex align-items-center justify-content-between w-100">
          <div className="d-flex align-items-center">
            <img
              src={icon}
              alt={title}
              style={{ width: 50, height: 54, objectFit: "contain" }}
              className="me-3"
            />
            <div>
              <h6 className="mb-1 text-dark">{title}</h6>
              <h2 className="fw-bold mb-0 text-dark">{value}</h2>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CatStatsCard;
